// Main sidebaar permissions
export const CLIENT_REPORTING = 'client_reporting-read';
export const CLIETN_COMPANIES = 'client_companies-read';
export const CLIENT_CASES = 'client_cases-read';
export const CLIENT_CASES_CREATE = 'client_cases-create';
export const CLIENT_CHATS = 'client_chats-read';
export const CLIENT_PROJECTS = 'client_projects-read';
export const CLIENT_CASES_UPDATE = 'client_cases-update';
export const CLIENT_PLANNING = 'client_planning-read';
export const CLIENT_QUOTATIONS = 'client_quotations-read';
export const CLIENT_INVOICES = 'client_invoices-read';
export const CLIENT_USERS = 'client_users-read';
export const CLIENT_ORDERS = 'client_orders-read';
export const CLIENT_ORDERS_CREATE = 'client_order-create';
export const CLIENT_SUBSCRIPTIONS = 'client_subscriptions-read';
export const CLIENT_SUBSCRIPTIONS_CREATE = 'client_subscriptions-create';
export const APPROVALS = 'approvals-read';
export const TESTING = 'testing-read';

// mindtime portal permissoin in main sidebar
export const CLIENT_DASHBOARD = 'client_dashboard-read';
export const CLIETN_HOME = 'client_home-read';
export const CLIENT_BACKUPS = 'client_backups-read';
export const CLIENT_EXPLORER = 'client_explorer-read';
export const CLIENT_BACKUP_USERS = 'client_backup_users-read';
export const CLIENT_PRICES = 'client_prices-read';
export const CLIENT_LISTS = 'client_lists-read';
export const CLIENT_HISTORY = 'client_history-read';
export const CLIENT_SUPPORT = 'client_support-read';
export const CLIENT_BACKUP_PORTAL = 'client_backup_portal-read';
export const CLIENT_MINDTIME_SECURITY = 'client_mindtime_security-read';

// Mindtime Security in main sidebar and these are the Child routes groups
export const CLIENT_MINDTIME_SECURITY_EDR = 'client_mindtime_security_edr-read';
export const CLIENT_MINDTIME_SECURITY_XDR = 'client_mindtime_security_xdr-read';
export const CLIENT_MINDTIME_SECURITY_SIEM = 'client_mindtime_security_siem-read';
export const CLIENT_MINDTIME_SECURITY_SSL_MANAGEMENT = 'client_mindtime_security_ssl_management-read';
export const CLIENT_MINDTIME_SECURITY_COMPLIANCE_SETTINGS =
  'client_mindtime_security_compliance_settings-read';


// Security routes permissions in security EDR sidebar under mindtime-security group
export const CLIENT_EDR_SOC = 'client_edr_soc-read';
export const CLIENT_EDR_GLOBAL_FILTERS = 'client_edr_global_filters-read';
export const CLIENT_EDR_GLOBAL_FILTERS_DATE_RANGE = 'client_edr_global_filters_date_range-read';
export const CLIENT_EDR_GLOBAL_FILTERS_ORGANIZATION = 'client_edr_global_filters_organization-read';
export const CLIENT_EDR_GLOBAL_FILTERS_SEARCH = 'client_edr_global_filters_search-read';
export const CLIENT_EDR_GLOBAL_FILTERS_ENDPOINT = 'client_edr_global_filters_endpoint-read';
export const CLIENT_EDR_RESELLER_DASHBOARD = 'client_edr_reseller_dashboard-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD = 'client_edr_sub_org_dashboard-read';
export const CLIENT_EDR_CLIENTS = 'client_edr_clients-read';
export const CLIENT_EDR_ENDPOINTS = 'client_edr_endpoints-read';
export const CLIENT_EDR_ENDPOINTS_DEPLOY_AGENT = 'client_edr_endpoints_deploy_agent-create';
export const CLIENT_EDR_MALWARE_DETECTION = 'client_edr_malware_detection-read';
export const CLIENT_EDR_AUTOMATED_RESPONSE = 'client_edr_automated_response-read';
export const CLIENT_EDR_FILE_INTEGRITY_MONITORING = 'client_edr_file_integrity_monitoring-read';
export const CLIENT_EDR_THREAT_HUNTING = 'client_edr_threat_hunting-read';
export const CLIENT_EDR_VULNERABILITIES_DETECTION = 'client_edr_vulnerabilities_detection-read';
export const CLIENT_EDR_MITRE_ATTACK = 'client_edr_mitre_attack-read';

export const CLIENT_EDR_CONFIGURATION_COMPLIANCE = 'client_edr_configuration_compliance-read';
export const CLIENT_EDR_CONFIGURATION_COMPLIANCE_ENDPOINT_COMPLIANCE =
  'client_edr_configuration_compliance_endpoint_compliance-read';
export const CLIENT_EDR_CONFIGURATION_COMPLIANCE_LIST =
  'client_edr_configuration_compliance_list-read';
export const CLIENT_EDR_CONFIGURATION_COMPLIANCE_SUMMARY =
  'client_edr_configuration_compliance_summary-read';

// EDR component permissions (subscription entitlements + role grants)
export const CLIENT_EDR_VULNERABILITIES_DETECTION_LIST =
  'client_edr_vulnerabilities_detection_list-read';
export const CLIENT_EDR_VULNERABILITIES_DETECTION_SUMMARY =
  'client_edr_vulnerabilities_detection_summary-read';
export const CLIENT_EDR_VULNERABILITIES_DETECTION_VULNERABLE_ENDPOINTS =
  'client_edr_vulnerabilities_detection_vulnerable_endpoints-read';

export const CLIENT_EDR_FILE_INTEGRITY_MONITORING_EVENTS =
  'client_edr_file_integrity_monitoring_events-read';
export const CLIENT_EDR_FILE_INTEGRITY_MONITORING_SUMMARY =
  'client_edr_file_integrity_monitoring_summary-read';
export const CLIENT_EDR_FILE_INTEGRITY_MONITORING_AFFECTED_ENDPOINTS =
  'client_edr_file_integrity_monitoring_affected_endpoints-read';

export const CLIENT_EDR_MALWARE_DETECTION_LIST = 'client_edr_malware_detection_list-read';
export const CLIENT_EDR_MALWARE_DETECTION_CATEGORIES_CHART =
  'client_edr_malware_detection_categories_chart-read';
export const CLIENT_EDR_MALWARE_DETECTION_SUMMARY = 'client_edr_malware_detection_summary-read';
export const CLIENT_EDR_MALWARE_DETECTION_INFECTED_ENDPOINTS =
  'client_edr_malware_detection_infected_endpoints-read';

export const CLIENT_EDR_AUTOMATED_RESPONSE_LIST = 'client_edr_automated_response_list-read';
export const CLIENT_EDR_AUTOMATED_RESPONSE_SUMMARY = 'client_edr_automated_response_summary-read';

export const CLIENT_EDR_THREAT_HUNTING_RESULTS_LIST = 'client_edr_threat_hunting_results_list-read';
export const CLIENT_EDR_THREAT_HUNTING_SUMMARY = 'client_edr_threat_hunting_summary-read';
export const CLIENT_EDR_THREAT_HUNTING_AFFECTED_ENDPOINTS =
  'client_edr_threat_hunting_affected_endpoints-read';

export const CLIENT_EDR_MITRE_ATTACK_TOP_TECHNIQUES = 'client_edr_mitre_attack_top_techniques-read';
export const CLIENT_EDR_MITRE_ATTACK_TECHNIQUES_LIST = 'client_edr_mitre_attack_techniques_list-read';
export const CLIENT_EDR_MITRE_ATTACK_SUMMARY = 'client_edr_mitre_attack_summary-read';
export const CLIENT_EDR_MITRE_ATTACK_AFFECTED_ENDPOINTS =
  'client_edr_mitre_attack_affected_endpoints-read';

export const CLIENT_EDR_CLIENTS_LIST = 'client_edr_clients_list-read';
export const CLIENT_EDR_CLIENTS_SUMMARY = 'client_edr_clients_summary-read';

export const CLIENT_EDR_ENDPOINTS_TABLE = 'client_edr_endpoints_table-read';
export const CLIENT_EDR_ENDPOINTS_AGENT_OVERVIEW = 'client_edr_endpoints_agent_overview-read';

export const CLIENT_EDR_ENDPOINT_DASHBOARD = 'client_edr_endpoint_dashboard-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_PORTFOLIO_HEALTH =
  'client_edr_endpoint_dashboard_portfolio_health-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_SECURITY_SCORE =
  'client_edr_endpoint_dashboard_security_score-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_CRITICAL_VULNERABILITIES =
  'client_edr_endpoint_dashboard_critical_vulnerabilities-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_FAILED_COMPLIANCE =
  'client_edr_endpoint_dashboard_failed_compliance-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_SECURITY_OVERVIEW =
  'client_edr_endpoint_dashboard_security_overview-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_ENDPOINT_SUMMARY =
  'client_edr_endpoint_dashboard_endpoint_summary-read';
export const CLIENT_EDR_ENDPOINT_DASHBOARD_ENDPOINT_HEALTH =
  'client_edr_endpoint_dashboard_endpoint_health-read';

export const CLIENT_EDR_ENDPOINT_TECHNICAL_DETAILS = 'client_edr_endpoint_technical_details-read';
export const CLIENT_EDR_ENDPOINT_TECHNICAL_DETAILS_INSTALL_COMMANDS =
  'client_edr_endpoint_technical_details_install_commands-read';

export const CLIENT_EDR_SUB_ORG_DASHBOARD_MOST_VULNERABLE_ENDPOINTS =
  'client_edr_sub_org_dashboard_most_vulnerable_endpoints-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_RECENT_CRITICAL_INCIDENTS =
  'client_edr_sub_org_dashboard_recent_critical_incidents-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_ENDPOINT_HEALTH =
  'client_edr_sub_org_dashboard_endpoint_health-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_RECOMMENDED_ACTIONS =
  'client_edr_sub_org_dashboard_recommended_actions-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_ENDPOINTS_REQUIRING_ACTION =
  'client_edr_sub_org_dashboard_endpoints_requiring_action-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_SECURITY_SCORE =
  'client_edr_sub_org_dashboard_security_score-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_PORTFOLIO_HEALTH =
  'client_edr_sub_org_dashboard_portfolio_health-read';
export const CLIENT_EDR_SUB_ORG_DASHBOARD_RECENT_ACTIVITY =
  'client_edr_sub_org_dashboard_recent_activity-read';

export const CLIENT_EDR_RESELLER_DASHBOARD_OPEN_TASKS =
  'client_edr_reseller_dashboard_open_tasks-read';
export const CLIENT_EDR_RESELLER_DASHBOARD_RECENT_CRITICAL_INCIDENTS =
  'client_edr_reseller_dashboard_recent_critical_incidents-read';
export const CLIENT_EDR_RESELLER_DASHBOARD_ENDPOINTS_REQUIRING_ACTION =
  'client_edr_reseller_dashboard_endpoints_requiring_action-read';
export const CLIENT_EDR_RESELLER_DASHBOARD_RECENT_CLIENT_ACTIVITY =
  'client_edr_reseller_dashboard_recent_client_activity-read';
export const CLIENT_EDR_RESELLER_DASHBOARD_CLIENTS_REQUIRING_ATTENTION =
  'client_edr_reseller_dashboard_clients_requiring_attention-read';
export const CLIENT_EDR_RESELLER_DASHBOARD_SECURITY_SCORE =
  'client_edr_reseller_dashboard_security_score-read';
export const CLIENT_EDR_RESELLER_DASHBOARD_PORTFOLIO_HEALTH =
  'client_edr_reseller_dashboard_portfolio_health-read';

/** Subscription-assignable permission identifiers (product catalog / org subscription API). */
export const SUBSCRIPTION_PERMISSIONS = {
  subscriptions: {
    read: CLIENT_SUBSCRIPTIONS,
    create: CLIENT_SUBSCRIPTIONS_CREATE,
  },
  mindtimeSecurity: {
    read: CLIENT_MINDTIME_SECURITY,
    edr: CLIENT_MINDTIME_SECURITY_EDR,
    xdr: CLIENT_MINDTIME_SECURITY_XDR,
    siem: CLIENT_MINDTIME_SECURITY_SIEM,
    sslManagement: CLIENT_MINDTIME_SECURITY_SSL_MANAGEMENT,
    complianceSettings: CLIENT_MINDTIME_SECURITY_COMPLIANCE_SETTINGS,
  },
  edrModules: {
    soc: CLIENT_EDR_SOC,
    globalFilters: CLIENT_EDR_GLOBAL_FILTERS,
    resellerDashboard: CLIENT_EDR_RESELLER_DASHBOARD,
    subOrgDashboard: CLIENT_EDR_SUB_ORG_DASHBOARD,
    endpoints: CLIENT_EDR_ENDPOINTS,
    deployAgent: CLIENT_EDR_ENDPOINTS_DEPLOY_AGENT,
    endpointDashboard: CLIENT_EDR_ENDPOINT_DASHBOARD,
    endpointTechnicalDetails: CLIENT_EDR_ENDPOINT_TECHNICAL_DETAILS,
    malwareDetection: CLIENT_EDR_MALWARE_DETECTION,
    automatedResponse: CLIENT_EDR_AUTOMATED_RESPONSE,
    fileIntegrityMonitoring: CLIENT_EDR_FILE_INTEGRITY_MONITORING,
    threatHunting: CLIENT_EDR_THREAT_HUNTING,
    vulnerabilitiesDetection: CLIENT_EDR_VULNERABILITIES_DETECTION,
    configurationCompliance: CLIENT_EDR_CONFIGURATION_COMPLIANCE,
    mitreAttack: CLIENT_EDR_MITRE_ATTACK,
  },
  edrComponents: {
    globalFilters: {
      dateRange: CLIENT_EDR_GLOBAL_FILTERS_DATE_RANGE,
      organization: CLIENT_EDR_GLOBAL_FILTERS_ORGANIZATION,
      search: CLIENT_EDR_GLOBAL_FILTERS_SEARCH,
      endpoint: CLIENT_EDR_GLOBAL_FILTERS_ENDPOINT,
    },
    vulnerabilitiesDetection: {
      list: CLIENT_EDR_VULNERABILITIES_DETECTION_LIST,
      summary: CLIENT_EDR_VULNERABILITIES_DETECTION_SUMMARY,
      vulnerableEndpoints: CLIENT_EDR_VULNERABILITIES_DETECTION_VULNERABLE_ENDPOINTS,
    },
    fileIntegrityMonitoring: {
      events: CLIENT_EDR_FILE_INTEGRITY_MONITORING_EVENTS,
      summary: CLIENT_EDR_FILE_INTEGRITY_MONITORING_SUMMARY,
      affectedEndpoints: CLIENT_EDR_FILE_INTEGRITY_MONITORING_AFFECTED_ENDPOINTS,
    },
    malwareDetection: {
      list: CLIENT_EDR_MALWARE_DETECTION_LIST,
      categoriesChart: CLIENT_EDR_MALWARE_DETECTION_CATEGORIES_CHART,
      summary: CLIENT_EDR_MALWARE_DETECTION_SUMMARY,
      infectedEndpoints: CLIENT_EDR_MALWARE_DETECTION_INFECTED_ENDPOINTS,
    },
    automatedResponse: {
      list: CLIENT_EDR_AUTOMATED_RESPONSE_LIST,
      summary: CLIENT_EDR_AUTOMATED_RESPONSE_SUMMARY,
    },
    threatHunting: {
      resultsList: CLIENT_EDR_THREAT_HUNTING_RESULTS_LIST,
      summary: CLIENT_EDR_THREAT_HUNTING_SUMMARY,
      affectedEndpoints: CLIENT_EDR_THREAT_HUNTING_AFFECTED_ENDPOINTS,
    },
    mitreAttack: {
      topTechniques: CLIENT_EDR_MITRE_ATTACK_TOP_TECHNIQUES,
      techniquesList: CLIENT_EDR_MITRE_ATTACK_TECHNIQUES_LIST,
      summary: CLIENT_EDR_MITRE_ATTACK_SUMMARY,
      affectedEndpoints: CLIENT_EDR_MITRE_ATTACK_AFFECTED_ENDPOINTS,
    },
    configurationCompliance: {
      list: CLIENT_EDR_CONFIGURATION_COMPLIANCE_LIST,
      summary: CLIENT_EDR_CONFIGURATION_COMPLIANCE_SUMMARY,
      endpointCompliance: CLIENT_EDR_CONFIGURATION_COMPLIANCE_ENDPOINT_COMPLIANCE,
    },
    endpoints: {
      table: CLIENT_EDR_ENDPOINTS_TABLE,
      agentOverview: CLIENT_EDR_ENDPOINTS_AGENT_OVERVIEW,
    },
    endpointDashboard: {
      portfolioHealth: CLIENT_EDR_ENDPOINT_DASHBOARD_PORTFOLIO_HEALTH,
      securityScore: CLIENT_EDR_ENDPOINT_DASHBOARD_SECURITY_SCORE,
      criticalVulnerabilities: CLIENT_EDR_ENDPOINT_DASHBOARD_CRITICAL_VULNERABILITIES,
      failedCompliance: CLIENT_EDR_ENDPOINT_DASHBOARD_FAILED_COMPLIANCE,
      securityOverview: CLIENT_EDR_ENDPOINT_DASHBOARD_SECURITY_OVERVIEW,
      endpointSummary: CLIENT_EDR_ENDPOINT_DASHBOARD_ENDPOINT_SUMMARY,
      endpointHealth: CLIENT_EDR_ENDPOINT_DASHBOARD_ENDPOINT_HEALTH,
    },
    endpointTechnicalDetails: {
      installCommands: CLIENT_EDR_ENDPOINT_TECHNICAL_DETAILS_INSTALL_COMMANDS,
    },
    subOrgDashboard: {
      mostVulnerableEndpoints: CLIENT_EDR_SUB_ORG_DASHBOARD_MOST_VULNERABLE_ENDPOINTS,
      recentCriticalIncidents: CLIENT_EDR_SUB_ORG_DASHBOARD_RECENT_CRITICAL_INCIDENTS,
      endpointHealth: CLIENT_EDR_SUB_ORG_DASHBOARD_ENDPOINT_HEALTH,
      recommendedActions: CLIENT_EDR_SUB_ORG_DASHBOARD_RECOMMENDED_ACTIONS,
      endpointsRequiringAction: CLIENT_EDR_SUB_ORG_DASHBOARD_ENDPOINTS_REQUIRING_ACTION,
      securityScore: CLIENT_EDR_SUB_ORG_DASHBOARD_SECURITY_SCORE,
      portfolioHealth: CLIENT_EDR_SUB_ORG_DASHBOARD_PORTFOLIO_HEALTH,
      recentActivity: CLIENT_EDR_SUB_ORG_DASHBOARD_RECENT_ACTIVITY,
    },
    resellerDashboard: {
      openTasks: CLIENT_EDR_RESELLER_DASHBOARD_OPEN_TASKS,
      recentCriticalIncidents: CLIENT_EDR_RESELLER_DASHBOARD_RECENT_CRITICAL_INCIDENTS,
      endpointsRequiringAction: CLIENT_EDR_RESELLER_DASHBOARD_ENDPOINTS_REQUIRING_ACTION,
      recentClientActivity: CLIENT_EDR_RESELLER_DASHBOARD_RECENT_CLIENT_ACTIVITY,
      clientsRequiringAttention: CLIENT_EDR_RESELLER_DASHBOARD_CLIENTS_REQUIRING_ATTENTION,
      securityScore: CLIENT_EDR_RESELLER_DASHBOARD_SECURITY_SCORE,
      portfolioHealth: CLIENT_EDR_RESELLER_DASHBOARD_PORTFOLIO_HEALTH,
    },
  },
} as const;

/** Flat list of all subscription product permission identifier strings. */
export const SUBSCRIPTION_PERMISSION_IDENTIFIERS: readonly string[] = [
  SUBSCRIPTION_PERMISSIONS.subscriptions.read,
  SUBSCRIPTION_PERMISSIONS.subscriptions.create,
  SUBSCRIPTION_PERMISSIONS.mindtimeSecurity.read,
  SUBSCRIPTION_PERMISSIONS.mindtimeSecurity.edr,
  SUBSCRIPTION_PERMISSIONS.mindtimeSecurity.xdr,
  SUBSCRIPTION_PERMISSIONS.mindtimeSecurity.siem,
  SUBSCRIPTION_PERMISSIONS.mindtimeSecurity.sslManagement,
  SUBSCRIPTION_PERMISSIONS.mindtimeSecurity.complianceSettings,
  SUBSCRIPTION_PERMISSIONS.edrModules.soc,
  SUBSCRIPTION_PERMISSIONS.edrModules.globalFilters,
  SUBSCRIPTION_PERMISSIONS.edrModules.resellerDashboard,
  SUBSCRIPTION_PERMISSIONS.edrModules.subOrgDashboard,
  SUBSCRIPTION_PERMISSIONS.edrModules.endpoints,
  SUBSCRIPTION_PERMISSIONS.edrModules.deployAgent,
  SUBSCRIPTION_PERMISSIONS.edrModules.endpointDashboard,
  SUBSCRIPTION_PERMISSIONS.edrModules.endpointTechnicalDetails,
  SUBSCRIPTION_PERMISSIONS.edrModules.malwareDetection,
  SUBSCRIPTION_PERMISSIONS.edrModules.automatedResponse,
  SUBSCRIPTION_PERMISSIONS.edrModules.fileIntegrityMonitoring,
  SUBSCRIPTION_PERMISSIONS.edrModules.threatHunting,
  SUBSCRIPTION_PERMISSIONS.edrModules.vulnerabilitiesDetection,
  SUBSCRIPTION_PERMISSIONS.edrModules.configurationCompliance,
  SUBSCRIPTION_PERMISSIONS.edrModules.mitreAttack,
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.globalFilters),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.vulnerabilitiesDetection),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.fileIntegrityMonitoring),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.malwareDetection),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.automatedResponse),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.threatHunting),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.mitreAttack),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.configurationCompliance),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.endpoints),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.endpointDashboard),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.endpointTechnicalDetails),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.subOrgDashboard),
  ...Object.values(SUBSCRIPTION_PERMISSIONS.edrComponents.resellerDashboard),
];

export type SubscriptionPermissionIdentifier = (typeof SUBSCRIPTION_PERMISSION_IDENTIFIERS)[number];

/** Map subscription/catalog permission id → reseller JWT role permission id (`client_*` → `reseller_*`). */
export const mapClientPermissionToResellerRole = (clientPermission: string): string =>
  String(clientPermission ?? '')
    .trim()
    .toLowerCase()
    .replace(/^client_/, 'reseller_');

export const RESELLER_MINDTIME_SECURITY = mapClientPermissionToResellerRole(CLIENT_MINDTIME_SECURITY);
export const RESELLER_MINDTIME_SECURITY_EDR = mapClientPermissionToResellerRole(
  CLIENT_MINDTIME_SECURITY_EDR,
);
export const RESELLER_MINDTIME_SECURITY_XDR = mapClientPermissionToResellerRole(
  CLIENT_MINDTIME_SECURITY_XDR,
);
export const RESELLER_MINDTIME_SECURITY_SIEM = mapClientPermissionToResellerRole(
  CLIENT_MINDTIME_SECURITY_SIEM,
);
export const RESELLER_MINDTIME_SECURITY_SSL_MANAGEMENT = mapClientPermissionToResellerRole(
  CLIENT_MINDTIME_SECURITY_SSL_MANAGEMENT,
);
export const RESELLER_MINDTIME_SECURITY_COMPLIANCE_SETTINGS = mapClientPermissionToResellerRole(
  CLIENT_MINDTIME_SECURITY_COMPLIANCE_SETTINGS,
);
export const RESELLER_EDR_SOC = mapClientPermissionToResellerRole(CLIENT_EDR_SOC);

/**
 * EDR Clients — JWT role only (not assignable via org subscription), including subscribed clients.
 * Still in the registry for nav/routes/`canWidget`; excluded from `SUBSCRIPTION_PERMISSION_IDENTIFIERS`.
 */
export const ROLE_ONLY_EDR_PERMISSION_IDENTIFIERS: readonly string[] = [
  CLIENT_EDR_CLIENTS,
  CLIENT_EDR_CLIENTS_LIST,
  CLIENT_EDR_CLIENTS_SUMMARY,
];

export const RESELLER_EDR_CLIENTS = mapClientPermissionToResellerRole(CLIENT_EDR_CLIENTS);
export const RESELLER_EDR_CLIENTS_LIST = mapClientPermissionToResellerRole(CLIENT_EDR_CLIENTS_LIST);
export const RESELLER_EDR_CLIENTS_SUMMARY = mapClientPermissionToResellerRole(CLIENT_EDR_CLIENTS_SUMMARY);

/**
 * Flat list of reseller JWT role permission identifiers for products + modules.
 * Subscription catalog keys + role-only EDR Clients, all with `reseller_*` prefix.
 */
export const RESELLER_ROLE_PERMISSION_IDENTIFIERS: readonly string[] = [
  ...SUBSCRIPTION_PERMISSION_IDENTIFIERS.map(mapClientPermissionToResellerRole),
  ...ROLE_ONLY_EDR_PERMISSION_IDENTIFIERS.map(mapClientPermissionToResellerRole),
];

export type ResellerRolePermissionIdentifier = (typeof RESELLER_ROLE_PERMISSION_IDENTIFIERS)[number];
